export const DialogType = {
  CONFIRMATION: 'confirmation',
  INFO: 'info',
  ERROR: 'error'
};